export default "__VITE_ASSET__BFBDgBiK__"